<section>
  <div class="flex justify-center bg-G50">
    <div class="max-w-[1440px] w-full py-[56px] px-[24px] md:px-[64px]">
      <div class="flex flex-col gap-12">
        <div
          class="flex flex-col md:flex-row md:justify-between gap-2 md:gap-[100px]"
        >
          <div class="md:max-w-[410px] grid gap-2">
            <div class="text-b2 text-G500">{{ featureSection.subTitle }}</div>
            <div
              class="text-h4 md:text-h3 text-G800 font-medium md:max-w-[410px] leading-[1.2]"
            >
              {{ featureSection.title }}
            </div>
          </div>
          <div class="md:max-w-[430px] grid gap-8 md:gap-4">
            <div class="text-b1 text-G700">
              {{ featureSection.description }}
            </div>
            <div class="w-max h-max" [routerLink]="['/inbox/post']">
              <basic-button
                [type]="isWindowWidthMd() ? 1 : 2"
                [title]="featureSection.buttonText1"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="pt-[48px]">
        <div *ngIf="tempProviderArray.length === 0">
          <p-carousel
            [value]="skeletonProviderArray"
            [numVisible]="4"
            [numScroll]="4"
            [circular]="false"
            [showIndicators]="true"
            [showNavigators]="false"
            [responsiveOptions]="responsiveOptions"
          >
            <ng-template let-profile pTemplate="item">
              <div class="m-auto w-full max-w-[304px]">
                <sk-profile-card />
              </div>
            </ng-template>
          </p-carousel>
        </div>

        <div *ngIf="tempProviderArray.length !== 0">
          <p-carousel
            [value]="tempProviderArray"
            [numVisible]="4"
            [numScroll]="4"
            [circular]="false"
            [showIndicators]="true"
            [showNavigators]="false"
            [responsiveOptions]="responsiveOptions"
          >
            <ng-template let-profile pTemplate="item">
              <div class="m-auto w-full h-full max-w-[304px]">
                <profile-card
                  [index]="profile.id"
                  [avatarUri]="profile.avatarUri"
                  [name]="profile.name"
                  [title]="profile.title"
                  [isVerified]="profile.verified"
                  [rating]="profile.rating"
                  [skillTags]="profile.skillTags"
                  [timezone]="profile.timezone"
                  [slug]="profile.slug"
                  [address]="profile.address"
                  [hourlyRate]="profile.hourlyRate"
                />
              </div>
            </ng-template>
          </p-carousel>
        </div>
      </div>
    </div>
  </div>
</section>
